// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n}", "",{"version":3,"sources":["/Users/bradwilliams/Desktop/Personal/wedding/src/styles.scss","styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;ACCF","file":"styles.scss","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n","* {\n  margin: 0;\n  padding: 0;\n}"]}]);
// Exports
module.exports = exports;
